import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { lightSkeletonTheme, darkSkeletonTheme } from "./skeletonTheme";

// Mirrors About.jsx: a dark diagonal-clip hero (title), sticky founder
// photo with stats, and the story copy + pull-quote column.
const AboutSkeleton = ({ navHeight }) => {
  return (
    <div
      className="w-full bg-[rgba(250,248,251,0.88)]"
      style={{ minHeight: navHeight ? `calc(100vh - ${navHeight}px)` : undefined }}
    >
      <div
        className="relative overflow-hidden bg-primary-dark pt-14 pb-16 md:pt-16 md:pb-20"
        style={{ clipPath: "polygon(0 0, 100% 0, 100% 90%, 50% 100%, 0 90%)" }}
      >
        <div className="outer-container container">
          <div className="max-w-6xl mx-auto px-6">
            <div className="relative max-w-3xl">
              <SkeletonTheme {...darkSkeletonTheme}>
                <Skeleton height={44} width="70%" containerClassName="block mb-2" />
                <Skeleton height={44} width="45%" containerClassName="block" />
              </SkeletonTheme>
            </div>
          </div>
        </div>
      </div>

      <div className="outer-container container">
        <div className="max-w-6xl mx-auto px-3 py-8 sm:py-12">
          <SkeletonTheme {...lightSkeletonTheme}>
            <div className="grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16 items-start">
              <div>
                <Skeleton className="aspect-[3/4]" borderRadius={22} />
                <div className="flex gap-7 mt-7">
                  <div>
                    <Skeleton width={56} height={28} containerClassName="block mb-1" />
                    <Skeleton width={64} height={12} />
                  </div>
                  <div>
                    <Skeleton width={56} height={28} containerClassName="block mb-1" />
                    <Skeleton width={64} height={12} />
                  </div>
                </div>
              </div>

              <div>
                <Skeleton count={6} height={16} containerClassName="block mb-3" />
                <div className="mt-8 pt-2">
                  <Skeleton count={2} height={20} containerClassName="block mb-2" />
                  <Skeleton width={36} height={2} containerClassName="block mt-3 mb-3" />
                  <Skeleton width={160} height={14} />
                </div>
              </div>
            </div>
          </SkeletonTheme>
        </div>
      </div>
    </div>
  );
};

export default AboutSkeleton;
